import { render, staticRenderFns } from "./RestrictedAlbumArticleItem.vue?vue&type=template&id=428c6209&"
import script from "./RestrictedAlbumArticleItem.vue?vue&type=script&lang=js&"
export * from "./RestrictedAlbumArticleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/daum/program/jenkins/workspace/cafe-web/cafe-web-production/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('428c6209')) {
      api.createRecord('428c6209', component.options)
    } else {
      api.reload('428c6209', component.options)
    }
    module.hot.accept("./RestrictedAlbumArticleItem.vue?vue&type=template&id=428c6209&", function () {
      api.rerender('428c6209', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/bbs-list/bottom/components/RestrictedAlbumArticleItem.vue"
export default component.exports